import { hasLeftCurrencySymbol, units } from '@exodus/fiat-currencies';
import libFormatCurrency from 'format-currency';
import { roundDecimalSignificantsUp } from './numbers.js';
export const LEFT_FORMAT = '%s%v';
export const RIGHT_FORMAT = '%v %s';
export const USD_SYMBOL = units.USD.symbol;
export function formatCurrency(input, { maxSignificant: rawMaxSignificant, ...rest } = {}) {
    const maxSignificant = rawMaxSignificant ? Math.min(rawMaxSignificant, 21) : rawMaxSignificant;
    const amount = roundDecimalSignificantsUp(input, maxSignificant);
    return libFormatCurrency(amount, {
        maxSignificant,
        ...rest,
    });
}
export function getCurrencySymbol(currency) {
    return units[currency]?.symbol;
}
export function getCurrencyFormat(currency) {
    return hasLeftCurrencySymbol(currency) ? LEFT_FORMAT : RIGHT_FORMAT;
}
export const formatNumber = (number, decimals = 0) => {
    return formatCurrency(number, {
        maxFraction: decimals,
        minFraction: decimals,
    });
};
